export default __webpack_public_path__ + "static/media/packages.697bb8bf.svg";